// extracted by mini-css-extract-plugin
module.exports = {"select":"_2UxN5o2wh5z5eFNiuQMu7Q"};